<div class="table-toolbar">
  <div class="dropdown-section">
    Lines per page
    <select class="form-select form-select-sm d-inline-block w-auto mx-2" [(ngModel)]="selectedLines"
      (ngModelChange)="updatePageSize(selectedLines)">
      <option *ngFor="let num of numbers" [value]="num.value">
        {{ num.viewValue }}
      </option>
    </select>
    entries
  </div>

  <div class="d-flex align-items-center gap-2">
    <div class="input-wrapper w-100" style="min-width: 350px;">
      <i class="ti ti-search input-icon"></i>
      <input class="form-control form-control-sm" [(ngModel)]="searchQuery" (ngModelChange)="search(searchQuery)"
        placeholder="Search..." type="text" />
    </div>

    <app-button *ngIf="hasFilters" autoClose="outside" label="Filters" icon="filter" size="lg"
      [ngbPopover]="filterPopover" popoverTitle="Filters" #popover="ngbPopover" placement="left-top"
      style="min-width: auto; width: auto; margin-left: auto;" iconPosition="left" buttonType="light" size="sm">
    </app-button>

    <ng-container *ngIf="hasToolbarFields">
      <form [formGroup]="toolbarForm!" class="d-flex align-items-center gap-2">
        <formly-form [form]="toolbarForm!" [fields]="toolbarFields!" [model]="toolbarModel!"></formly-form>
      </form>
    </ng-container>

  </div>
</div>

<hr class="toolbar-separator">

<ng-template #filterPopover>
  <app-filter-custom-popover *ngIf="filterForm && filterFields && filterModel" [formGroup]="filterForm"
    [fields]="filterFields" [model]="filterModel" (submitFilter)="onFilterSubmit()" (resetFilter)="onFilterReset()">
  </app-filter-custom-popover>
</ng-template>